<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown>
                <template slot="button-content">
                    <i class="cus-note"></i>
                    Notes
                </template>
                <b-dropdown-item @click="loadList()">
                    <i class="cus-note"></i>View Notes
                </b-dropdown-item>
                <div
                    class="dropdown-divider"
                    v-if="statusActive && _hasAccess('client.notes.create')"
                ></div>
                <b-dropdown-item
                    v-if="statusActive && _hasAccess('client.notes.create')"
                    @click.stop="addNote()"
                >
                    <i class="cus-add"></i> New Notes
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <list-notes :key="componentKey" />
        </b-card-text>
    </b-tab>
</template>
<script>
export default {
    components: {
        ListNotes: () => import("@/components/client-notes/note-list")
    },
    data() {
        return {
            componentKey: 0
        };
    },
    computed: {
        statusActive() {
            return this.$store.getters["client/statusActive"];
        }
    },
    mounted() {},
    methods: {
        reloadNotes() {
            this.loadList();
        },
        loadList() {
            this.componentKey += 1;
        },
        addNote() {
            this.$parent.$parent.$refs.modalNewNote.open();
        }
    }
};
</script>
